import { gettext } from '@eventbrite/i18n';

export const SUBHEADER = gettext(
    'Get out on the town with these fan-favorite organizers.',
);
